// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/pagination.css';
import './assets/css/table-actions.css';
// import elformdesign from 'el-form-design'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );
import tinymce from 'tinymce';
Vue.use( tinymce );


import AxiosPlugin from './libs/AxiosPlugin'
import store from './store/'
import App from './App'
Vue.use(AxiosPlugin)
// Vue.use(ElementUI);
// Vue.use(elformdesign);
Vue.config.productionTip = false;

import api from './utils/api.js'
Vue.prototype.api = api

import fun from './utils/function.js'
Vue.prototype.fun = fun

// 导入并注册权限指令
import permission from './utils/permission.js'
Vue.directive('permission', permission)

// 全局权限检查方法
Vue.prototype.$hasPermission = function(permission) {
  return store.getters.hasPermission(permission);
};

Vue.prototype.$hasAnyPermission = function(permissions) {
  return store.getters.hasAnyPermission(permissions);
};

Vue.prototype.$hasAllPermissions = function(permissions) {
  return store.getters.hasAllPermissions(permissions);
};

// 路由守卫：未登录跳转登录页
router.beforeEach(async (to, from, next) => {
  // 登录页不需要验证
  if (to.path === '/login') {
    next();
    return;
  }
  
  // 检查 token（使用 fun.getToken 方法）
  const token = fun.getToken();
  if (!token) {
    next({ path: '/login' });
  } else {
    // 检查是否已加载用户权限
    if (!store.state.mutations.userPermissions || store.state.mutations.userPermissions.length === 0) {
      // 获取用户数据和权限
      try {
        await store.dispatch('getUserData');
      } catch (error) {
        console.error('获取用户权限失败:', error);
      }
    }
    next();
  }
})


/* eslint-disable no-new */
const messages = {
  'en-US': {
    header: {
      title: 'FormMaking',
      document: 'Docs',
      pricing: 'Pricing',
      advanced: 'Advanced',
    }
  },
  'zh-CN': {
    header: {
      title: '表单设计器',
      document: '使用文档',
      pricing: '商业授权',
      advanced: '高级版本',
    }
  }
}

const i18n = new VueI18n({
  messages: {
    'en-US': {
      ...enLocale, ...messages['en-US']
    },
    'zh-CN': {
      ...zhLocale, ...messages['zh-CN']
    }
  }
})

Vue.use(ElementUI, { 
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
import FormMaking from 'form-making'
import 'form-making/dist/FormMaking.css'
Vue.use(FormMaking, {
  i18n
})
new Vue({
  i18n,
  store,
  api,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js